import { render, staticRenderFns } from "./oridepman.vue?vue&type=template&id=00633e5e&scoped=true&"
import script from "./oridepman.vue?vue&type=script&lang=js&"
export * from "./oridepman.vue?vue&type=script&lang=js&"
import style0 from "./oridepman.vue?vue&type=style&index=0&id=00633e5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00633e5e",
  null
  
)

export default component.exports